import { useEffect, useRef, useState, Fragment, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useParams, useLocation, useHistory } from "react-router-dom";
import Table from "components/__new/common/Table";
import DownloadAsCSV from "components/__new/common/DownloadAsCSV";
import SortBy from "components/__new/common/SortBy";
import Print from "components/__new/common/Print";
import Pagination from "components/__new/common/pagination";
import SearchBox from "components/__new/common/SearchBox";
import Maybe from "components/__new/common/Maybe";
import DynamicHeadTag from "components/__new/common/DynamicHeadTag";
import FormDrawer from "components/__new/common/form-drawer";
import DropdownNew from "utils/dropdown";
// import { Menu } from "@headlessui/react";
// import useMultiSelect from "hooks/useMultiSelect";
import { ButtonLoader, Checkbox, Input, SelectInput } from "components/__new/common/form";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ReactToolTip from "react-tooltip";
import { TransactionDetails } from "components/__new/payroll/runPayroll/TransactionDetails";
import { ReactComponent as IconEdit } from "assets/images/icons/project-icons/edit-pen.svg";
import { ReactComponent as IconEdit2 } from "assets/images/icons/project-icons/edit-pen-2.svg";
import { ReactComponent as IconsTimes } from "assets/images/icons/project-icons/times.svg";
// import { ReactComponent as IconLayers } from "assets/images/icons/project-icons/layers.svg";
// import { ReactComponent as IconsCaretUp } from "assets/images/icons/project-icons/caret-up.svg";
// import { ReactComponent as IconsCaretDown } from "assets/images/icons/project-icons/caret-down.svg";
// import { ReactComponent as IconDotH } from "assets/images/icons/project-icons/dots-v.svg";
// import { ReactComponent as IconTableConfig } from "assets/images/icons/project-icons/table.svg";
import { ReactComponent as IconDrag } from "assets/images/icons/project-icons/drag.svg";
import { ReactComponent as IconThrash } from "assets/images/icons/project-icons/thrash-2.svg";
import { ReactComponent as IconDocumentSearch } from "assets/images/icons/project-icons/document-search.svg";
import { ReactComponent as IconInformationFill } from "assets/images/icons/project-icons/information-fill.svg";
import { ReactComponent as IconInformationOutline } from "assets/images/icons/project-icons/information-outline.svg";
import { ReactComponent as IconCheckboxBorder } from "assets/images/icons/project-icons/checkbox-border.svg";
import { ReactComponent as IconComment } from "assets/images/icons/project-icons/comment.svg";
import { ReactComponent as IconLeft } from "assets/images/icons/project-icons/arrow-left.svg";
import { ReactComponent as IconReject } from "assets/images/icons/project-icons/reject-red.svg";
import { ReactComponent as IconApprove } from "assets/images/icons/project-icons/approve-white.svg";
import { ReactComponent as IconShare } from "assets/images/icons/project-icons/share.svg";

import PageContent from "components/__new/common/PageContent";
import DateFormat, { DaysLeft, MonthYearFormat } from "utils/dateFormat";
import { TableContent } from "components/__new/common/TableContent";
import NumberFormat from "utils/numberFormat";
import CurrencyFormat from "utils/currencyFormat";
import useUrlQueryParams from "hooks/useUrlQueryParams";
import processParams from "utils/processParams";
import useUrlNavigation from "hooks/useUrlNavigation";
import { toast } from "react-toastify";
import { useReactToPrint } from 'react-to-print';
import { TaxAndDeductionSummary } from "components/__new/payroll/runPayroll/TaxAndDeductionSummary";
import { PayrollMetrics } from "components/__new/payroll/runPayroll/PayrollMetrics";
import { transformPayrollName } from "utils/payroll/transformPayrollName";
import logger from "utils/logger";
import useLoginInfo from "hooks/useLoginInfo";
import * as payrollAction from "store/entities/payroll/runPayroll/action";
import usePayrollEssentials from "hooks/usePayrollEssentials";
import { ApprovalRequestModal, PayrollApprovalConfirmation, PayrollRejectionConfirmation } from "components/__new/payroll/runPayroll/ActionModals"
import useInlinePageRouter from "components/__new/general/useInlinePageRouter";
import { PaySlip } from "./pay-slip";


const Index = () => {
    const history = useHistory();
    const {id} = useParams();
    const location = useLocation();
    const dispatch = useDispatch();
    const {urlQuery} = useUrlNavigation();
    const {urlQueryParams} = useUrlQueryParams();
    const {userInfo} = useLoginInfo();
    const paySlipRef = useRef(null);
    // const { selections, toggleMultiSelectHeader, getMultiSelectBody, clearSelections, toggleSelectAll } = useMultiSelect();
    const {
        payrollLoading, payroll, payrollTransactionsGenerateLoading, payrollTransactionsGenerate,
        payrollTransactionsLoading, payrollTransactions, payrollTransactionsDownloadLoading, payrollTransactionsDownload,
        updatePayrollTransactionLoading, updatePayrollTransaction, payrollStatusUpdateLoading
    } = useSelector((s) => s.entities.runPayroll);
    const {getPayrollStatusStyle} = usePayrollEssentials();

    
    
    const downloadAsCSVRef = useRef();
    const printComponentRef = useRef();
    
    const paginationData = useMemo(() => {
        if (!payrollTransactions?.data) return {};
        
        const { data, ...paginationInfo } = payrollTransactions;
        return paginationInfo;
    }, [payrollTransactions])
    
    
    const [view, setView] = useState("Payee List");
	const { InlineRouterTab } = useInlinePageRouter("Payee List");
    const [isOpenPayrollDetails, setIsOpenPayrollDetails] = useState(false);
    const [isOpenEmployeeDetails, setIsOpenEmployeeDetails] = useState(false);
    const [isOpenTableConfig, setIsOpenTableConfig] = useState(false);
    const [isOpenCustomColumn, setIsOpenCustomColumn] = useState(false);
    const [isCommentShown, setIsCommentShown] = useState(false);
    const [isOpenEmployeeBDEmpty, setIsEmployeeBDEmpty] = useState({
        isOpen: false,
        type: "",
    });
    const [isOpenEmployeeBDList, setIsEmployeeBDList] = useState({
        isOpen: false,
        type: "",
    });
    const [isOpenEmployeeBDAdd, setIsEmployeeBDAdd] = useState({
        isOpen: false,
        type: "",
    });
    const [listParams, setListParams] = useState({
        "page": 1,
        "limit": 20,
    });
    const [sortOptions, setSortOptions] = useState([
        {
            title: <>Date Created <FontAwesomeIcon icon="arrow-up" className="ml-2 mt-0.5" /></>,
            link: urlQuery("sort=createdAt&order=asc"),
            data: {sort: 'createdAt', order: 'asc'},
            active: false,
        },
        {
            title: <>Date Created <FontAwesomeIcon icon="arrow-down" className="ml-2 mt-0.5" /></>,
            link: urlQuery("sort=createdAt&order=desc"),
            data: {sort: 'createdAt', order: 'desc'},
            active: false,
        },
    ]);
    const [transaction, setTransaction] = useState({});
    const [formTableConfig, formSetTableConfig] = useState({
        entryMode: "single",
    })
    const [formSingleBD, setFormSingleBD] = useState({
        isVisible: false,
        type: "", // bonus || deduction
        value: "",
    })
    
    const [action, setAction] = useState("");
    const [isOpenSendForApproval, setIsOpenSendForApproval] = useState(false);
    const [isOpenApprovePayrun, setIsOpenApprovePayrun] = useState(false);
    const [isOpenRejectPayrun, setIsOpenRejectPayrun] = useState(false);
    const [showPaySlip, setShowPaySlip] = useState(false);

    const columns = [
        {
            name: "Workdays",
            active: true,
            required: false,
        },
        {
            name: "Gross Pay",
            active: true,
            required: true,
        },
        {
            name: "Net Pay",
            active: true,
            required: true,
        },
        {
            name: "On-demand Pay",
            active: true,
            required: true,
        },
        {
            name: "Manual Deduction",
            active: true,
            required: false,
        },
        {
            name: "Manual Bonus",
            active: true,
            required: false,
        },
        {
            name: "Custom",
            active: true,
            required: false,
        },
        {
            name: "Cons. Relief",
            active: false,
            required: false,
        },
        {
            name: "PAYE",
            active: false,
            required: false,
        },
    ]
    
    const printPaySlip = useReactToPrint({
        content: () => paySlipRef.current,
        onBeforeGetContent: () => {
            setShowPaySlip(true);
            return new Promise((resolve) => {
                setTimeout(resolve, 0);
            });
        },
        onAfterPrint: () => setShowPaySlip(false),
    });

    const handlePrintPayslip = (transaction) => {
        setTransaction(transaction);
        printPaySlip();
    };

    const viewEmployeeDetails = (transaction) => {
        setTransaction(transaction);
        setIsOpenEmployeeDetails(true);
    }


    const updateEmployeeBonusDeduction = (type, transaction) => {
        setTransaction(transaction);

        let savedValue = 0;
        if (type === "bonus"){
            savedValue = transaction?.manual_bonuses || 0;
        }
        else if (type === "deduction"){
            savedValue = transaction?.manual_deductions || 0;
        }

        if (formTableConfig.entryMode === "single"){
            setFormSingleBD({
                isVisible: true,
                type,
                value: savedValue,
            })
        }
        else if (formTableConfig.entryMode === "multiple"){
            // if empty
            updateEmployeeBonusDeductionEmpty(type, true);

            // else
            // setIsEmployeeBDList({
            //     ...isOpenEmployeeBDList,
            //     type,
            //     isOpen: true,
            // });
        }
    }


    const updateEmployeeBonusDeductionEmpty = (type, isOpen) => {
        setIsEmployeeBDEmpty({
            ...isOpenEmployeeBDEmpty,
            isOpen,
            type,
        });
    }


    const updateEmployeeBonusDeductionList = (type, isOpen) => {
        setIsEmployeeBDList({
            ...isOpenEmployeeBDList,
            isOpen,
            type,
        });
    }


    const updateEmployeeBonusDeductionAdd = (type, isOpen) => {
        setIsEmployeeBDAdd({
            ...isOpenEmployeeBDAdd,
            isOpen,
            type,
        });
    }


    const submitFormSingleBD = async (e) => {
        e.preventDefault();

        const transactionId = transaction?.id;
        const type = formSingleBD.type;
        const params = {
            value: parseFloat(formSingleBD?.value),
        }

        if (type === "bonus"){
            dispatch(payrollAction.updateManualBonus(transactionId, params));
        }
        else if (type === "deduction"){
            if (params?.value <= transaction?.net_pay){
                dispatch(payrollAction.updateManualDeduction(transactionId, params));
            }
            else{
                toast.error("Sorry, the deduction cannot be greater than the net pay");
            }
        }
    }


    const clearFormSingleBD = () => {
        setFormSingleBD({
            isVisible: false,
            type: "",
            value: 0,
        })
    }


    const closePayrollTransactionsUpdate = () => {
        if (formTableConfig.entryMode === "single"){
            clearFormSingleBD();
        }
        else if (formTableConfig.entryMode === "multiple"){
            setIsEmployeeBDList({...isOpenEmployeeBDList, isOpen: false});
        }
    }


    const getPayrollDetails = () => {
        dispatch(payrollAction.getPayrollDetails(id));
    }


    const getPayrollTransactions = () => {
        let params = {...listParams};

        params = processParams(urlQueryParams, params, "page", "number", 1, "page");
        params = processParams(urlQueryParams, params, "limit", "number", 20, "limit");
        params = processParams(urlQueryParams, params, "search", "string", "", "search");
        params = processParams(urlQueryParams, params, "sort", "string", "", "sortBy");
        params = processParams(urlQueryParams, params, "order", "string", "", "sortOrder");

        const sortValue = urlQueryParams["sort"];
        const orderValue = urlQueryParams["order"];
        if (sortValue && orderValue) {
            const newSortOptions = sortOptions?.map((sortOption) => {
                if (sortOption?.data?.sort === sortValue && sortOption?.data?.order === orderValue) {
                    return {...sortOption, active: true};
                }
                else {
                    return {...sortOption, active: false};
                }
            })
            setSortOptions(newSortOptions);
        }

        setListParams(params);
        dispatch(payrollAction.getPayrollTransactions(id, params));
    }


    const refetchPayrollInformation = () => {
        getPayrollDetails();
        // getPayrollTransactions();
        // getPayrollTaxAndDeductionSummary();
    }


    const resetGeneratePayrollTransactions = () => {
        dispatch(payrollAction.resetGeneratePayrollTransactions());
    }
    
    
    const toggleApprovalRequest = () => setIsOpenSendForApproval(!isOpenSendForApproval);
    const toggleApprovalConfirmation = () => setIsOpenApprovePayrun(!isOpenApprovePayrun);
    
    const toggleRejectionConfirmation = () => setIsOpenRejectPayrun(!isOpenRejectPayrun);
    
    
    const sendPayrunForApproval = () => {
        setAction("in-review");
        logger("Employer-payroll-runpayroll-approve-payrun-attempt", userInfo);
        dispatch(payrollAction.sendPayrollForReview(payroll?.id)).then(() => toggleApprovalRequest());
    }


    const approvePayrun = (comment) => {
        const params = {
            status: "approved",
            comment
        }
        setAction("approve");
        logger("Employer-payroll-runpayroll-approve-payrun-success", userInfo);
        dispatch(payrollAction.updatePayrollStatus(payroll?.id, params)).then(() => toggleApprovalConfirmation());
    }



    const rejectPayrun = (comment) => {
        const params = {
            status: "rejected",
            comment,
        }
        setAction("reject");
        dispatch(payrollAction.updatePayrollStatus(payroll?.id, params)).then(() => {
            toggleRejectionConfirmation();
            getPayrollTransactions();
        });
    }


    useEffect(() => {
        if (id){
            getPayrollDetails();
        }
        // eslint-disable-next-line
    }, []);



    useEffect(() => {
        if (payroll?.id !== undefined){
            if (payrollTransactionsLoading === false){
                getPayrollTransactions();
            }
        }
        // eslint-disable-next-line
    }, [payroll, location]);


    useEffect(() => {
        if (Array.isArray(payrollTransactionsGenerate)){
            resetGeneratePayrollTransactions();
            getPayrollDetails();
        }
        // eslint-disable-next-line
    }, [payrollTransactionsGenerate]);


    useEffect(() => {
        if (updatePayrollTransaction?.id !== undefined){
            getPayrollDetails();
            closePayrollTransactionsUpdate();
            dispatch(payrollAction.resetUpdateManualBonusDeduction());
            toast.success("Payroll transaction updated");
        }
        // eslint-disable-next-line
    }, [updatePayrollTransaction]);


    return (
        <div>


            <ReactToolTip id="update-bd-btn" className="tooptip-size">
                Update
            </ReactToolTip>
            <ReactToolTip id="cancel-bd-btn" className="tooptip-size">
                Cancel
            </ReactToolTip>


            <DynamicHeadTag
                headerText={id + " - Run Payroll"}
                headerDescription=""
            />


            <TableConfig
                isOpen={isOpenTableConfig}
                setIsOpen={setIsOpenTableConfig}
                columns={columns}
                formTableConfig={formTableConfig}
                formSetTableConfig={formSetTableConfig}
            />


            <BonusDeductionEmpty
                isOpen={isOpenEmployeeBDEmpty.isOpen}
                setIsOpen={(e) => setIsEmployeeBDEmpty({...isOpenEmployeeBDEmpty, isOpen: e})}
                type={isOpenEmployeeBDEmpty.type}
                updateEmployeeBonusDeductionAdd={updateEmployeeBonusDeductionAdd}
            />
            
            {
                showPaySlip && (
                    <PaySlip
                        transaction={transaction}
                        payroll={payroll}
                        ref={paySlipRef}
                    />
                )
            }


            <BonusDeductionList
                isOpen={isOpenEmployeeBDList.isOpen}
                setIsOpen={(e) => setIsEmployeeBDList({...isOpenEmployeeBDList, isOpen: e})}
                type={isOpenEmployeeBDList.type}
                updateEmployeeBonusDeductionAdd={updateEmployeeBonusDeductionAdd}
            />


            <BonusDeductionAdd
                isOpen={isOpenEmployeeBDAdd.isOpen}
                setIsOpen={(e) => setIsEmployeeBDAdd({...isOpenEmployeeBDAdd, isOpen: e})}
                type={isOpenEmployeeBDAdd.type}
                updateEmployeeBonusDeductionList={updateEmployeeBonusDeductionList}
                updateEmployeeBonusDeductionEmpty={updateEmployeeBonusDeductionEmpty}
            />


            <CustomColumn
                isOpen={isOpenCustomColumn}
                setIsOpen={setIsOpenCustomColumn}
            />


            <TransactionDetails
                isOpen={isOpenEmployeeDetails}
                setIsOpen={setIsOpenEmployeeDetails}
                transaction={transaction}
            />


            <PayrollDetails
                isOpen={isOpenPayrollDetails}
                setIsOpen={setIsOpenPayrollDetails}
                payroll={payroll}
                refetchPayrollInformation={refetchPayrollInformation}
                userInfo={userInfo}
                logger={logger}
                action={action}
                setAction={setAction}
                isOpenRejectPayrun={isOpenRejectPayrun}
                setIsOpenRejectPayrun={setIsOpenRejectPayrun}
            />


            <ApprovalRequestModal
                isOpen={isOpenSendForApproval}
                onProceed={sendPayrunForApproval}
                onCancel={toggleApprovalRequest}
                loading={payrollStatusUpdateLoading}
            />


            <PayrollApprovalConfirmation
                isOpen={isOpenApprovePayrun}
                onProceed={approvePayrun}
                onCancel={toggleApprovalConfirmation}
                loading={payrollStatusUpdateLoading}
            />


            <PayrollRejectionConfirmation
                isOpen={isOpenRejectPayrun}
                onProceed={rejectPayrun}
                onCancel={toggleRejectionConfirmation}
                loading={payrollStatusUpdateLoading}
            />


            <div className="mt-3 lg:flex">
                <div className="w-full lg:w-1/2">
                    <div className="page-title flex items-center">
                        <div className="flex items-center justify-center bg-[#ECECEC] h-12 rounded-xl" style={{ width: "3.5rem" }}>
                            <IconLeft 
                                className="text-2xl cursor-pointer w-6 h-6" 
                                // onClick={() => history.push("/payroll")} 
                                onClick={() => {
                                    history.goBack();
                                }} 
                            />
                        </div>
                        <span className="font-medium ml-3 capitalize">{payroll?.name?.includes("_") ? transformPayrollName(payroll?.name || "-") : payroll?.name}</span>
                    </div>
                </div>
                {/* <div className="w-full lg:w-1/2 flex mt-4 lg:mt-0 lg:justify-end space-x-3">

                    <Maybe condition={payrollLoading === false && payroll?.id !== undefined}>

                        <Maybe condition={payroll?.status === "draft"}>
                            <button type="button" onClick={toggleApprovalRequest} className="btn btn-ep-primary">
                                Send for Approval
                            </button>
                        </Maybe>

                        <Maybe condition={payroll?.status === "in-review"}>
                            <div className="flex items-center justify-center">
                                <button type="button" onClick={() => setIsOpenRejectPayrun(true)} className="mr-5 btn border border-ep-danger text-ep-danger">
                                    <IconReject className="mr-1.5" />
                                    Reject
                                </button>
                                    
                                <button type="button" onClick={() => toggleApprovalConfirmation()} className="btn btn-ep-primary">
                                    <IconApprove className="mr-1.5" />
                                    Approve
                                </button>
                            </div>
                        </Maybe>

                        <Maybe condition={payroll?.status === "approved"}>
                            <button type="button" onClick={() => setIsOpenPayrollDetails(true)} className="btn btn-ep-primary">
                                Finalize Payrun
                            </button>
                        </Maybe>

                        <Maybe condition={payroll?.status === "rejected"}>
                            <button type="button" onClick={() => setIsOpenPayrollDetails(true)} className="btn btn-ep-primary">
                                View Payrun
                            </button>
                        </Maybe>

                        <Maybe condition={payroll?.status === "processing"}>
                            <button type="button" onClick={() => setIsOpenPayrollDetails(true)} className="btn btn-ep-primary">
                                View Payrun
                            </button>
                        </Maybe>

                        <Maybe condition={payroll?.status === "completed"}>
                            <button type="button" onClick={() => setIsOpenPayrollDetails(true)} className="btn btn-ep-primary">
                                View Payrun
                            </button>
                        </Maybe>
                    </Maybe>

                </div> */}
            </div>


            <Maybe condition={payrollLoading === false}>
                <div className="flex items-center justify-start mt-5 mb-4">
                    {/* <div className="mt-4 mb-3 flex items-center text-sm">
                        <span>Status:&nbsp;</span>
                        <label className={"py-1 px-2 w-max flex items-center justify-center rounded-full capitalize text-xs " + getPayrollStatusStyle(payroll?.status)}>
                                {payroll?.status}
                        </label>
                    </div> */}
                    
                    <Maybe condition={payroll?.status === "approved" || payroll?.status === "rejected"}>
                        <div className="">
                            <span onClick={() => setIsCommentShown(!isCommentShown)} className="flex items-center text-right text-ep-primary whitespace-nowrap cursor-pointer hover:underline text-sm">
                                {isCommentShown ? "Hide" : "See"} Comment
                                <IconComment className="ml-2" />
                            </span>
                        </div>
                    </Maybe>
                </div>
            </Maybe>
            
            
            <Maybe condition={isCommentShown === true}>
                <Maybe condition={payroll?.status === "approved"}>
                    <div className="px-4 py-2 my-4 bg-ep-primary-100 rounded-lg w-full lg:w-2/5 capitalize">
                        {payroll?.comment ?? "-"}
                    </div>
                </Maybe>
                <Maybe condition={payroll?.status === "rejected"}>
                    <div className="px-4 py-2 my-4 bg-[#FEF2F2] rounded-lg w-full lg:w-2/5 capitalize">
                        {payroll?.comment ?? "-"}
                    </div>
                </Maybe>
            </Maybe>
            
            <Maybe condition={payrollLoading === false && payroll?.id !== undefined}>
                {/* <div className="flex flex-wrap mt-3">
                    <div className="mr-4 mb-4">
                        Payroll selection:
                        <span className="ml-2 text-ep-primary font-medium capitalize">
                            <Maybe condition={payroll?.pay_selection === "ALL_EMPLOYEES"}>
                                All Employees
                            </Maybe>
                            <Maybe condition={payroll?.pay_selection === "PAY_GROUPS"}>
                                {payroll?.metadata?.pay_groups?.map((pay_group, index) => {
                                    let data = "";
                                    if (index > 0){
                                        data += ", ";
                                    }
                                    data += pay_group?.name;
                                    return data;
                                })}
                                {!payroll?.metadata?.pay_groups && <span>Pay Groups</span>}
                            </Maybe>
                        </span>
                    </div>
                    <div className="mr-4 mb-4">
                        Payroll month:
                        <span className="w-max px-3 py-2 ml-1 font-medium text-ep-primary rounded-md">
                            {monthNames[payroll?.schedule?.month -1] || "-"} {payroll?.schedule?.year}
                        </span>
                    </div>
                    <div className="mr-4 mb-4">
                        Period:
                        <span className="ml-2 text-ep-secondary-600">
                            {DateFormat(payroll?.payroll_date_range?.start_date) || "-"}
                            &nbsp;-&nbsp;
                            {DateFormat(payroll?.payroll_date_range?.end_date) || "-"}
                        </span>
                    </div>
                </div> */}
                <div className="flex flex-col lg:flex-row mb-8 py-6 px-4 bg-white rounded-xl payroll-info-card flex-wrap gap-6">
                    <div className="w-max px-3 lg:pr-6 lg:border-r border-gray-200 lg:mb-0 pl-0">
                        <div className="text-base text-[#718096]">
                            Payroll Date
                        </div>
                        <div className="mt-2 text-sm font-medium bg-[#F2F4F7] rounded-2xl px-3 py-1 text-[#344054] w-fit" style={{ marginLeft: "-2px" }}>
                            {DateFormat(payroll?.payroll_date_range?.end_date) || "-"}
                        </div>
                    </div>
                    <div className="w-max px-3 pl-0 lg:pr-6 lg:border-r border-gray-200 lg:mb-0">
                        <div className="text-base text-[#718096]">
                            Period
                        </div>
                        <div className="mt-2 text-sm font-medium bg-[#F2F4F7] rounded-2xl px-3 py-1 text-[#344054] w-fit" style={{ marginLeft: "-2px" }}>
                            {DateFormat(payroll?.payroll_date_range?.start_date) || "-"}
                            &nbsp;-&nbsp;
                            {DateFormat(payroll?.payroll_date_range?.end_date) || "-"}
                        </div>
                    </div>
                    <Maybe condition={payroll?.status?.toLowerCase() !== "completed" && payroll?.status?.toLowerCase() !== "rejected"}>
                        <div className="w-max px-3 pl-0 lg:pr-6 lg:border-r border-gray-200 lg:mb-0">
                            <div className="text-base text-[#718096]">
                                Days Left
                            </div>
                            <div className="mt-2 text-sm font-medium bg-[#F2F4F7] rounded-2xl px-3 py-1 text-[#344054] w-fit" style={{ marginLeft: "-2px" }}>
                                {DaysLeft(payroll?.payroll_date_range?.end_date) || "-"}
                            </div>
                        </div>
                    </Maybe>
                    <div className="w-max px-3 pl-0 lg:pr-6 lg:border-r border-gray-200 lg:mb-0">
                        <div className="text-base text-[#718096]">
                            Payroll Status
                        </div>
                        <div className={`mt-2 text-sm font-medium capitalize rounded-2xl px-3 py-1 w-fit ${getPayrollStatusStyle(payroll?.status)}`} style={{ marginLeft: "-2px" }}>
                            {payroll?.status}
                        </div>
                    </div>
                    <div className="flex flex-col items-start lg:items-center justify-center pl-0 lg:pr-6 ">
                        <Maybe condition={payroll?.status === "draft"}>
                            <button type="button" onClick={toggleApprovalRequest} className="btn btn-ep-primary h-12">
                                <span>Send for Approval</span>
                                <IconShare />
                            </button>
                        </Maybe>

                        <Maybe condition={payroll?.status === "in-review"}>
                            <div className="flex items-center justify-center">
                                <button type="button" onClick={() => setIsOpenRejectPayrun(true)} className="mr-5 btn border border-ep-danger text-ep-danger">
                                    <IconReject className="mr-1.5" />
                                    Reject
                                </button>
                                    
                                <button type="button" onClick={() => toggleApprovalConfirmation()} className="btn btn-ep-primary">
                                    <IconApprove className="mr-1.5" />
                                    Approve
                                </button>
                            </div>
                        </Maybe>

                        <Maybe condition={payroll?.status === "approved"}>
                            <button type="button" onClick={() => setIsOpenPayrollDetails(true)} className="btn btn-ep-primary">
                                Finalize Payrun
                            </button>
                        </Maybe>

                        <Maybe condition={payroll?.status === "rejected"}>
                            <button type="button" onClick={() => setIsOpenPayrollDetails(true)} className="btn btn-ep-primary">
                                View Payrun
                            </button>
                        </Maybe>

                        <Maybe condition={payroll?.status === "processing"}>
                            <button type="button" onClick={() => setIsOpenPayrollDetails(true)} className="btn btn-ep-primary">
                                View Payrun
                            </button>
                        </Maybe>

                        <Maybe condition={payroll?.status === "completed"}>
                            <button type="button" onClick={() => setIsOpenPayrollDetails(true)} className="btn btn-ep-primary">
                                View Payrun
                            </button>
                        </Maybe>
                    </div>
                </div>
            </Maybe>


            <PageContent
                loading={payrollLoading}
                data={payroll?.id}
                classes="mt-6 box"
                loadingText="Loading payroll data"
                emptyText="Payroll data not found"
                errorText="Unable to load payroll data"
            />


            <Maybe condition={payrollLoading === false && payroll?.id !== undefined}>

                <PayrollMetrics
                    loading={payrollTransactionsGenerateLoading}
                    data={payroll}
                />


                <div className="mt-12">
                    {/* <TabSettings options={[
                        {
                            title: <span>Payee List</span>,
                            type: "div",
                            isActive: (view === "Payee List" ? true : false),
                            onclick: () => setView("Payee List"),
                        },
                        {
                            title: <span>Tax & Deduction Summary</span>,
                            type: "div",
                            isActive: (view === "Tax & Deduction Summary" ? true : false),
                            onclick: () => setView("Tax & Deduction Summary"),
                        },
                    ]} /> */}
                    <div className="flex items-center">
                        <InlineRouterTab
                            tabMode
                            defaultTab={view}
                            onTabChange={(activeItem) => setView(activeItem)}
                            containerClassName="w-1/2"
                            items={[
                                {
                                    title: "Payee List",
                                    value: "Payee List",
                                },
                                {
                                    title: "Tax & Deduction Summary",
                                    value: "Tax & Deduction Summary",
                                },
                            ]}
                        />
                    </div>
                </div>


                <Maybe condition={view === "Payee List"}>
                    <div className="mt-6 box">

                        <Maybe condition={payrollTransactionsGenerateLoading === true}>
                            <PageContent
                                loading={payrollTransactionsGenerateLoading}
                                loadingText="Generating payroll transactions"
                            />
                        </Maybe>

                        <Maybe condition={payrollTransactionsGenerateLoading === false}>
                            <div className="flex flex-wrap justify-between">
                                <div className="max-w-sm flex-grow sm:mr-6">
                                    <SearchBox placeholder="Search payees..." name="search" extraUrlParams="page=1" />
                                </div>
                                    
                                <div className="flex flex-wrap space-x-3 sm:space-x-6">
                                    <div className="relative flex justify-end payroll-sortby" style={{ width: "200px" }}>
                                        <SortBy options={sortOptions} title=" " firstOption="Sort by" />
                                    </div>
                                    
                                    <div>
                                        <DownloadAsCSV
                                            ref={downloadAsCSVRef}
                                            tooltip="Download payee list"
                                            filename="Payee list.csv"
                                            columns={[
                                                { label: "Employee name", key: "employee_name" },
                                                { label: "Employee number", key: "employee_number" },
                                                { label: "Workdays", key: "days_worked"},
                                                { label: "Gross Pay", key: "gross_pay" },
                                                { label: "Net Pay", key: "net_pay" },
                                                { label: "On-demand Pay", key: "on_demand_pay" },
                                                { label: "Manual Deductions", key: "manual_deductions" },
                                                { label: "Manual Bonus", key: "manual_bonuses" },
                                                { label: "Custom", key: "" },
                                                { label: "Pension", key: "pension_deduction.employee_amount" },
                                                { label: "NHF", key: "nhf" },
                                                { label: "NSITF", key: "nsitf" },
                                                { label: "ITF", key: "itf" },
                                            ]}
                                            click={() => {
                                                dispatch(payrollAction.downloadPayrollTransactions(id, {...listParams, page: 1, limit: 2000})).then(() => {
                                                    downloadAsCSVRef.current?.downloadData();
                                                });
                                            }}
                                            loading={payrollTransactionsDownloadLoading}
                                            response={payrollTransactionsDownload?.data}
                                        />
                                    </div>

                                    <div>
                                        <Print component={printComponentRef} />
                                    </div>
                                </div>
                            </div>

                            
                            <div className="mt-6">
                                <div ref={printComponentRef}>

                                    <div className="mb-4 text-xl hidden print:block">
                                        Payee List
                                    </div>
                                    
                                    <Table>
                                        <Table.Head>
                                            {/* <th></th> */}
                                            <th>Name</th>
                                            <th>Workdays</th>
                                            <Maybe condition={payroll?.type === "GROSS"}>
                                                <th>Gross Pay </th>
                                            </Maybe>
                                            <th>Net Pay</th>
                                            <th>On-demand Pay</th>
                                            <th>Manual Deductions</th>
                                            <th>Manual Bonus</th>
                                            <th className="hidden">
                                                <div onClick={() => setIsOpenCustomColumn(true)} className="w-max flex items-center border-b border-transparent hover:border-gray-700 cursor-pointer">
                                                    Custom
                                                    <IconEdit2 className="ml-2" />
                                                </div>
                                            </th>
                                            <Maybe condition={payroll?.status?.toLowerCase() === "completed"}>
                                                <th></th>
                                            </Maybe>
                                            <Maybe condition={payroll?.type === "GROSS"}>
                                                <th></th>
                                            </Maybe>
                                        </Table.Head>
                                        <Table.Body>

                                            <TableContent
                                                loading={payrollTransactionsLoading}
                                                loadingText="Loading payroll transactions"
                                                data={payrollTransactions?.data || []}
                                                colspan={9}
                                            />

                                            {payrollTransactionsLoading === false && payrollTransactions?.data?.map((payrollTransaction) =>
                                                <tr key={payrollTransaction?.id}>
                                                    {/* 
                                                    <td>
                                                        <input
                                                            type="checkbox"
                                                            className="form-checkbox w-5 h-5 multi-select"
                                                            onChange={getMultiSelectBody}
                                                            checked={selections?.filter((selection) => JSON.parse(selection).id === payrollTransaction?.id)?.length === 1}
                                                            value={JSON.stringify(payrollTransaction)}
                                                        />
                                                    </td>
                                                    */}
                                                    <td>
                                                        <div className="font-medium capitalize">
                                                            {payrollTransaction?.employee_name || "-"}
                                                        </div>
                                                        <div className="text-fade">
                                                            {payrollTransaction?.employee_number || "-"}
                                                        </div>
                                                    </td>
                                                    <td className="text-fade-3">
                                                        {NumberFormat(payrollTransaction?.days_worked, "no-kobo") || "-"}
                                                    </td>
                                                    <Maybe condition={payroll?.type === "GROSS"}>
                                                        <td className="text-fade-3">
                                                            {CurrencyFormat(payrollTransaction?.gross_pay, "no-kobo") || "-"}
                                                        </td>
                                                    </Maybe>
                                                    <td className="text-fade-3">
                                                        {CurrencyFormat(payrollTransaction?.net_pay, "no-kobo") || "-"}
                                                    </td>
                                                    <td className="text-fade-3">
                                                        {CurrencyFormat(payrollTransaction?.on_demand_pay, "no-kobo") || "-"}
                                                    </td>
                                                    <td className="text-fade-3">
                                                        <Maybe condition={!(transaction?.id === payrollTransaction?.id && formSingleBD?.isVisible === true && formSingleBD?.type === "deduction" && payroll?.status?.toLowerCase() === "draft")}>
                                                            <div onClick={() => updateEmployeeBonusDeduction("deduction", payrollTransaction)} className={`w-max flex items-center border-b border-transparent hover:border-gray-700 ${payroll?.status?.toLowerCase() === "draft" ? "cursor-pointer" : ""}`}>
                                                                {CurrencyFormat(payrollTransaction?.manual_deductions, "no-kobo") || "-"}
                                                                <IconEdit2 className="ml-2" />
                                                            </div>
                                                        </Maybe>
                                                        
                                                        <Maybe condition={transaction?.id === payrollTransaction?.id && formSingleBD?.isVisible === true && formSingleBD?.type === "deduction" && payroll?.status?.toLowerCase() === "draft"}>
                                                            <form onSubmit={submitFormSingleBD}>
                                                                <Input
                                                                    type="text"
                                                                    label=""
                                                                    placeholder="Eg: 25000"
                                                                    value={formSingleBD.value}
                                                                    onChange={(e) => setFormSingleBD({...formSingleBD, value: e.target.value})}
                                                                    containerClass="!max-w-[150px] !mb-0"
                                                                    inputClass="!w-full !min-w-[150px] !pt-[0] !pb-[0] !pl-[6px] !pr-[58px]"
                                                                    rightIcon={
                                                                        <div className="h-full flex space-x-0">
                                                                            <Maybe condition={updatePayrollTransactionLoading === true}>
                                                                                <div data-tip data-for="update-bd-btn" title="Update" className="w-8 h-full flex bg-ep-primary opacity-70 cursor-pointer">
                                                                                    <FontAwesomeIcon icon="circle-notch" spin className="text-xl m-auto text-white" />
                                                                                </div>
                                                                            </Maybe>
                                                                            <Maybe condition={updatePayrollTransactionLoading === false}>
                                                                                <div onClick={submitFormSingleBD} data-tip data-for="update-bd-btn" title="Update" className="w-8 h-full flex bg-ep-primary cursor-pointer">
                                                                                    <FontAwesomeIcon icon="check" className="m-auto text-white" />
                                                                                </div>
                                                                            </Maybe>
                                                                            <div onClick={clearFormSingleBD} data-tip data-for="cancel-bd-btn" title="Cancel" className="w-8 h-full flex bg-red-500 cursor-pointer rounded-tr rounded-br">
                                                                                <FontAwesomeIcon icon="times" className="m-auto text-white" />
                                                                            </div>
                                                                        </div>
                                                                    }
                                                                />
                                                            </form>
                                                        </Maybe>

                                                    </td>
                                                    <td className="text-fade-3">

                                                        <Maybe condition={!(transaction?.id === payrollTransaction?.id && formSingleBD?.isVisible === true && formSingleBD?.type === "bonus" && payroll?.status?.toLowerCase() === "draft")}>
                                                            <div onClick={() => updateEmployeeBonusDeduction("bonus", payrollTransaction)} className={`w-max flex items-center border-b border-transparent hover:border-gray-700 ${payroll?.status?.toLowerCase() === "draft" ? "cursor-pointer" : ""}`}>
                                                                {CurrencyFormat(payrollTransaction?.manual_bonuses, "no-kobo") || "-"}
                                                                <IconEdit2 className="ml-2" />
                                                            </div>
                                                        </Maybe>
                                                        <Maybe condition={transaction?.id === payrollTransaction?.id && formSingleBD?.isVisible === true && formSingleBD?.type === "bonus" && payroll?.status?.toLowerCase() === "draft"}>
                                                            <form onSubmit={submitFormSingleBD}>
                                                                <Input
                                                                    type="text"
                                                                    label=""
                                                                    placeholder="Eg: 25000"
                                                                    value={formSingleBD.value}
                                                                    onChange={(e) => setFormSingleBD({...formSingleBD, value: e.target.value})}
                                                                    containerClass="!max-w-[150px] !mb-0"
                                                                    inputClass="!w-full !min-w-[150px] !pt-[0] !pb-[0] !pl-[6px] !pr-[58px]"
                                                                    rightIcon={
                                                                        <div className="h-full flex space-x-0">
                                                                            <Maybe condition={updatePayrollTransactionLoading === true}>
                                                                                <div data-tip data-for="update-bd-btn" title="Update" className="w-8 h-full flex bg-ep-primary opacity-70 cursor-pointer">
                                                                                    <FontAwesomeIcon icon="circle-notch" spin className="text-xl m-auto text-white" />
                                                                                </div>
                                                                            </Maybe>
                                                                            <Maybe condition={updatePayrollTransactionLoading === false}>
                                                                                <div onClick={submitFormSingleBD} data-tip data-for="update-bd-btn" title="Update" className="w-8 h-full flex bg-ep-primary cursor-pointer">
                                                                                    <FontAwesomeIcon icon="check" className="m-auto text-white" />
                                                                                </div>
                                                                            </Maybe>
                                                                            <div onClick={clearFormSingleBD} data-tip data-for="cancel-bd-btn" title="Cancel" className="w-8 h-full flex bg-red-500 cursor-pointer rounded-tr rounded-br">
                                                                                <FontAwesomeIcon icon="times" className="m-auto text-white" />
                                                                            </div>
                                                                        </div>
                                                                    }
                                                                />
                                                            </form>
                                                        </Maybe>

                                                    </td>
                                                    <td className="text-fade-3 hidden">
                                                        <div className="w-max flex items-center border-b border-transparent hover:border-gray-700 cursor-pointer">
                                                            {/* ₦0.00 */}
                                                            -
                                                            <IconEdit2 className="ml-2" />
                                                        </div>
                                                    </td>
                                                   <Maybe condition={payroll?.status?.toLowerCase() === "completed"}>
                                                        <td>
                                                            <DropdownNew iconClassName="rotate-90" onClick={() => console.log("clicked")}>
                                                                <></>
                                                                <div>
                                                                    <div 
                                                                        onClick={() => {
                                                                            handlePrintPayslip(payrollTransaction);
                                                                        }} 
                                                                        className="dropdown-item dropdown-item-icon"
                                                                    >
                                                                        Download Payslip
                                                                    </div>
                                                                </div>
                                                            </DropdownNew>
                                                        </td>
                                                   </Maybe>
                                                    <Maybe condition={payroll?.type === "GROSS"}>
                                                        <td>
                                                            <DropdownNew>
                                                                <></>
                                                                <div>
                                                                    <div onClick={() => viewEmployeeDetails(payrollTransaction)} className="dropdown-item dropdown-item-icon">
                                                                        <IconEdit />
                                                                        View Details
                                                                    </div>
                                                                </div>
                                                            </DropdownNew>
                                                        </td>
                                                    </Maybe>
                                                </tr>
                                            )}

                                        </Table.Body>
                                    </Table>

                                    <Maybe condition={payrollTransactionsLoading === false && payrollTransactions?.data?.length > 0}>
                                        <div className="mt-6">
                                            <Pagination data={paginationData} limit={paginationData?.limit} />
                                        </div>
                                    </Maybe>

                                </div>
                            </div>
                        </Maybe>

                    </div>
                </Maybe>


                <Maybe condition={view === "Tax & Deduction Summary"}>
                    <div className="mt-6 px-0 box">
                        <TaxAndDeductionSummary
                            id={id} 
                            payroll={payroll}
                        />
                    </div>
                </Maybe>
            </Maybe>


        </div>
    )
}


export const TableConfig = (props) => {
    const { isOpen, setIsOpen, columns, formTableConfig } = props;


    const [form, setForm] = useState(formTableConfig);


    const submitForm = async (e) => {
        e.preventDefault();
    }


    return (
        <FormDrawer display="center" size="4xl" isOpen={isOpen} setIsOpen={setIsOpen}>
            <form onSubmit={submitForm} className="p-8">
                <div className="font-bold text-[#0D0C2B] text-lg sm:text-xl">
                    Table settings
                </div>
                <div className="mt-8">
                    

                    <div>
                        <div>
                            Table column
                        </div>
                        <div className="mt-2 flex flex-wrap">
                            {columns?.map((column, index) =>
                                <Fragment key={index}>
                                    <Maybe condition={column.required === true}>
                                        <div className="label px-3 py-1 text-white text-sm bg-gray-400 mr-2 mb-2 cursor-pointer">
                                            {column.name}
                                        </div>
                                    </Maybe>
                                    
                                    <Maybe condition={column.required === false}>
                                        <Maybe condition={column.active === true}>
                                            <div className="label px-3 py-1 text-white text-sm bg-ep-primary mr-2 mb-2 cursor-pointer">
                                                {column.name}
                                            </div>
                                        </Maybe>

                                        <Maybe condition={column.active === false}>
                                            <div className="label px-3 py-1 text-sm bg-white border border-gray-400 mr-2 mb-2 cursor-pointer">
                                                {column.name}
                                            </div>
                                        </Maybe>
                                    </Maybe>
                                </Fragment>
                            )}
                        </div>
                    </div>


                    <div className="mt-6">
                        <div>
                            Column order
                        </div>
                        <div className="pt-2 pl-2 mt-2 flex flex-wrap bg-[#D5DBE5] rounded-md">
                            {columns?.map((column, index) =>
                                <div key={index} className="label mr-2 mb-2 flex items-center px-3 py-1 bg-white border-red-300 text-sm shadow-md cursor-pointer">
                                    <IconDrag className="mr-2" />
                                    <div>{column.name}</div>
                                </div>
                            )}
                        </div>
                    </div>


                    <div className="mt-10">
                        <div>
                            Manual Bonus/Deduction mode
                        </div>
                        <div className="mt-2 flex flex-wrap">
                            <div className="mr-8">
                                <Checkbox
                                    type="radio"
                                    label="Single Entry"
                                    checked={form.entryMode === "single"}
                                    onChange={(e) => setForm({...form, entryMode: "single"})}
                                />
                            </div>
                            <div className="mr-8">
                                <Checkbox
                                    type="radio"
                                    label="Multiple Entries"
                                    checked={form.entryMode === "multiple"}
                                    onChange={(e) => setForm({...form, entryMode: "multiple"})}
                                />
                            </div>
                        </div>
                    </div>


                    <div className="pt-10 mt-10 border-t border-gray-200 flex space-x-3 justify-start">
                        <button type="submit" className="btn btn-md btn-ep-primary">
                            Apply
                        </button>
                        <button type="button" className="btn btn-md btn-transparent-primary">
                            Reset
                        </button>
                        <button type="button" onClick={() => setIsOpen(false)} className="btn btn-md text-ep-primary hover:bg-gray-100">
                            Cancel
                        </button>
                    </div>


                </div>
            </form>
        </FormDrawer>
    )
}


export const BonusDeductionEmpty = (props) => {
    const { isOpen, setIsOpen, type, updateEmployeeBonusDeductionAdd } = props;
    return (
        <FormDrawer display="center" size="lg" isOpen={isOpen} setIsOpen={setIsOpen}>
            <div className="p-8">
                <div className="font-bold text-[#0D0C2B] text-lg sm:text-xl">
                    Custom <span className="capitalize">{type}</span> for Employee
                </div>
                    
                <div className="mt-14 flex justify-center">
                    <IconDocumentSearch />
                </div>

                <div className="mt-14 w-48 mx-auto flex flex-col space-y-2">
                    <button type="button" onClick={() => updateEmployeeBonusDeductionAdd(type, true)} className="btn btn-block btn-md btn-ep-primary">
                        Add <span className="capitalize">&nbsp;{type}</span>
                    </button>
                    <button type="button" onClick={() => setIsOpen(false)} className="btn btn-block btn-md text-ep-primary hover:bg-gray-100">
                        Close
                    </button>
                </div>
            </div>
        </FormDrawer>
    )
}


export const BonusDeductionList = (props) => {
    const { isOpen, setIsOpen, type, updateEmployeeBonusDeductionAdd } = props;
    
    const [form] = useState([
        {
            name: "Food Item",
            frequency: "6 times",
            frequencyType: "occurrences",
            amount: "₦220,000",
        },
        {
            name: "Food Item",
            frequency: "June",
            frequencyType: "fixed-month",
            amount: "₦220,000",
        },
    ])

    const submitForm = () => {
        // submit to be
        setIsOpen(false);
    }

    return (
        <FormDrawer display="center" size="4xl" isOpen={isOpen} setIsOpen={setIsOpen}>
            <div className="p-8">
                <div className="font-bold text-[#0D0C2B] text-lg sm:text-xl">
                    Custom <span className="capitalize">{type}</span> for Employee
                </div>
                    
                <div className="mt-10">
                    <div className="flex space-x-4 justify-between">
                        <div className="flex-grow sm:flex sm:space-x-4 space-y-1 sm:space-y-0">
                            <div className="w-full sm:w-1/3">
                                Name of <span className="capitalize">{type}</span>
                            </div>
                            <div className="w-full sm:w-1/3 flex items-center">
                                <div>
                                    Frequency
                                </div>
                                <div>
                                    <IconInformationOutline
                                        className="w-4 ml-2"
                                        data-tip
                                        data-for="frequency-info"
                                    />
                                </div>
                                <ReactToolTip id="frequency-info" className="tooptip-size max-w-[250px]">
                                    Frequency refers to either either 
                                    <ul className="pl-6 list-disc">
                                        <li>
                                            Number of occurrences (1-6)
                                        </li>
                                        <li>
                                            Fixed month - a specific month is when the event is to end
                                        </li>
                                    </ul>
                                </ReactToolTip>
                            </div>
                            <div className="w-full sm:w-1/3">
                                Amount
                            </div>
                        </div>
                        <div className="w-24 flex-shrink-0"></div>
                    </div>

                    {form?.map((data, index) =>
                        <div key={index} className="mt-8 sm:mt-4 flex space-x-4 justify-between">
                            <div className="flex-grow sm:flex sm:space-x-4 space-y-1 sm:space-y-0">
                                <div className="w-full sm:w-1/3">
                                    <Input type="text" label="" value={data.name} containerClass="mb-0" disabled={true} />
                                </div>
                                <div className="w-full sm:w-1/3">
                                    <Input
                                        type="text"
                                        label=""
                                        value={data.frequency}
                                        containerClass="mb-0"
                                        disabled={true}
                                        rightIcon={
                                            <IconInformationFill
                                                className="w-4 ml-2"
                                                data-tip
                                                data-for={data.frequencyType || ""}
                                            />
                                        }
                                    />
                                </div>
                                <div className="w-full sm:w-1/3">
                                    <Input type="text" label="" value={data.amount} containerClass="mb-0" disabled={true} />
                                </div>
                            </div>
                            <div className="w-24 flex-shrink-0 flex space-x-4">
                                <div className="w-10 flex hover:bg-gray-100 cursor-pointer">
                                    <IconEdit2 className="w-5 h-5 m-auto svg-outline-dark" />
                                </div>
                                <div className="w-10 flex hover:bg-gray-100 cursor-pointer">
                                    <IconThrash className="w-5 h-5 m-auto" />
                                </div>
                            </div>
                        </div>
                    )}
                </div>

                <ReactToolTip id="occurrences" className="tooptip-size max-w-[250px]">
                    Number of occurrences (1-6) of event
                </ReactToolTip>

                <ReactToolTip id="fixed-month" className="tooptip-size max-w-[250px]">
                    A specific month is when the event is to end
                </ReactToolTip>

                <div className="mt-12 flex space-x-3">
                    <button type="button" onClick={() => updateEmployeeBonusDeductionAdd(type, true)} className="btn btn-md btn-ep-primary">
                        Add New Data
                    </button>
                    <button type="button" onClick={submitForm} className="btn btn-md btn-transparent-primary">
                        Save
                    </button>
                    <button type="button" onClick={() => setIsOpen(false)} className="btn btn-md text-ep-primary hover:bg-gray-100">
                        Cancel
                    </button>
                </div>
            </div>
        </FormDrawer>
    )
}


export const BonusDeductionAdd = (props) => {
    const { isOpen, setIsOpen, type, updateEmployeeBonusDeductionList, updateEmployeeBonusDeductionEmpty } = props;

    const [form, setForm] = useState({
        name: "",
        frequency: "",
        occurrences: "",
        fixedMonth: "",
        amount: "",
    })

    const submitForm = async (e) => {
        e.preventDefault();
        setIsOpen(false);
        updateEmployeeBonusDeductionEmpty("", false);
        updateEmployeeBonusDeductionList(type, true);
    }

    return (
        <FormDrawer display="center" size="lg" isOpen={isOpen} setIsOpen={setIsOpen}>
            <form onSubmit={submitForm} className="p-8">
                <div className="font-bold text-[#0D0C2B] text-lg sm:text-xl">
                    Add New Data
                </div>
                    
                <div className="mt-6 pt-6 text-sm border-t border-gray-200">
                    <Input type="text" label={"Name of " + type} placeholder={"Input name of " + type} value={form.name} onChange={(e) => setForm({...form, name: e.target.value})} />

                    <div className="my-6 py-6 border-t border-b border-gray-200">
                        <div className="flex items-center">
                            <div>
                                Frequency
                            </div>
                            <div>
                                <IconInformationOutline
                                    className="w-4 ml-2"
                                    data-tip
                                    data-for="frequency-info"
                                />
                            </div>
                            <ReactToolTip id="frequency-info" className="tooptip-size max-w-[250px]">
                                Frequency refers to either either 
                                <ul className="pl-6 list-disc">
                                    <li>
                                        Number of occurrences (1-6)
                                    </li>
                                    <li>
                                        Fixed month - a specific month is when the event is to end
                                    </li>
                                </ul>
                            </ReactToolTip>
                        </div>

                        <div className="mt-4 flex justify-between space-x-4">
                            <div className="flex items-center">
                                <Checkbox
                                    type="radio"
                                    label="Occurrences"
                                    checked={form.frequency === "occurrences"}
                                    onChange={(e) => setForm({...form, frequency: "occurrences"})}
                                />
                                <IconInformationOutline
                                    className="w-4 ml-2"
                                    data-tip
                                    data-for="occurrences"
                                />
                                <ReactToolTip id="occurrences" className="tooptip-size max-w-[250px]">
                                    Number of occurrences (1-6) of event
                                </ReactToolTip>
                            </div>
                            <div className="flex space-x-4 items-center">
                                <Input
                                    type="text"
                                    label=""
                                    placeholder="0"
                                    containerClass="w-12 mb-0"
                                    inputClass="text-center"
                                    value={form.occurrences}
                                    onChange={(e) => setForm({...form, occurrences: e.target.value})}
                                    disabled={form.frequency !== "occurrences"}
                                />
                                <div>
                                    Occurrence(s)
                                </div>
                            </div>
                        </div>

                        <div className="mt-2 flex justify-between space-x-4">
                            <div className="flex items-center">
                                <Checkbox
                                    type="radio"
                                    label="Fixed Month"
                                    checked={form.frequency === "fixed-month"}
                                    onChange={(e) => setForm({...form, frequency: "fixed-month"})}
                                />
                                <IconInformationOutline
                                    className="w-4 ml-2"
                                    data-tip
                                    data-for="fixed-month"
                                />
                                <ReactToolTip id="fixed-month" className="tooptip-size max-w-[250px]">
                                    A specific month is when the event is to end
                                </ReactToolTip>
                            </div>
                            <div className="w-[9.5rem]">
                                <SelectInput
                                    label=""
                                    containerClass="mb-0"
                                    value={form.fixedMonth}
                                    onChange={(e) => setForm({...form, fixedMonth: e.target.value})}
                                    disabled={form.frequency !== "fixed-month"}
                                >
                                    <option value="">Select Month</option>
                                    <option value="">Month 1</option>
                                    <option value="">Month 2</option>
                                    <option value="">Month 3</option>
                                </SelectInput>
                            </div>
                        </div>
                    </div>

                    <Input type="number" label="Amount" placeholder={"Input amount of " + type} value={form.amount} onChange={(e) => setForm({...form, amount: e.target.value})} />
                </div>

                <div className="mt-6 flex space-x-3">
                    <button type="submit" className="btn btn-md btn-ep-primary">
                        Add Data
                    </button>
                    <button type="button" onClick={() => setIsOpen(false)} className="btn btn-white btn-md">
                        Cancel
                    </button>
                </div>
            </form>
        </FormDrawer>
    )
}


export const CustomColumn = (props) => {
    const { isOpen, setIsOpen } = props;

    const [form, setForm] = useState({
        name: "",
        type: "",
    })

    const submitForm = async (e) => {
        e.preventDefault();
        setIsOpen(false);
    }

    return (
        <FormDrawer display="center" size="lg" isOpen={isOpen} setIsOpen={setIsOpen}>
            <form onSubmit={submitForm} className="p-8">
                <div className="font-bold text-[#0D0C2B] text-lg sm:text-xl">
                    Custom Column
                </div>
                    
                <div className="mt-6 pt-6 pb-8 text-sm border-t border-b border-gray-200">
                    <Input type="text" label="Name of column" placeholder="Custom" value={form.name} onChange={(e) => setForm({...form, name: e.target.value})} />

                    <div>
                        <div className="">
                            Column Type
                        </div>
                        <div className="mt-4 space-y-4">
                            <div onClick={() => setForm({...form, type: "bonus"})} className={`form-choose ${form.type === "bonus" && "form-choose-active"}`}>
                                <div>
                                    <div className="font-normal">
                                        Bonus
                                    </div>
                                    <div className="form-choose-checkbox">
                                        <div className="form-choose-checkbox-empty"></div>
                                        <IconCheckboxBorder className="w-full h-full form-choose-checkbox-icon" />
                                    </div>
                                </div>
                            </div>
                            <div onClick={() => setForm({...form, type: "deduction"})}className={`form-choose ${form.type === "deduction" && "form-choose-active"}`}>
                                <div>
                                    <div className="font-normal">
                                        Deduction
                                    </div>
                                    <div className="form-choose-checkbox">
                                        <div className="form-choose-checkbox-empty"></div>
                                        <IconCheckboxBorder className="w-full h-full form-choose-checkbox-icon" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="mt-8 flex space-x-3">
                    <button type="submit" className="btn btn-md btn-ep-primary">
                        Save
                    </button>
                    <button type="button" onClick={() => setIsOpen(false)} className="btn btn-white btn-md">
                        Cancel
                    </button>
                </div>
            </form>
        </FormDrawer>
    )
}


export const PayrollDetails = (props) => {
    const { isOpen, setIsOpen, payroll, refetchPayrollInformation, userInfo, logger, action, setAction, setIsOpenRejectPayrun } = props;
    const history = useHistory();


    const dispatch = useDispatch();
    const { payrollStatusUpdateLoading, payrollStatusUpdate } = useSelector((s) => s.entities.runPayroll);

    
    const sendPayrunForApproval = () => {
        setAction("in-review");
        logger("Employer-payroll-runpayroll-approve-payrun-attempt", userInfo);
        dispatch(payrollAction.sendPayrollForReview(payroll?.id));
    }
    
    
    // const approvePayrun = (comment) => {
    //     const params = {
    //         status: "approved",
    //         comment,
    //     }
    //     setAction("approve");
    //     logger("Employer-payroll-runpayroll-approve-payrun-success", userInfo);
    //     dispatch(payrollAction.updatePayrollStatus(payroll?.id, params));
    // }


    // const rejectPayrun = (comment) => {
    //     const params = {
    //         status: "rejected",
    //         comment,
    //     }
    //     setAction("reject");
    //     dispatch(payrollAction.updatePayrollStatus(payroll?.id, params));
    // }


    // const finalizePayrun = () => {
    //     const params = {
    //         status: "processing",
    //     }
    //     dispatch(payrollAction.updatePayrollStatus(payroll?.id, params));
    // }


    useEffect(() => {
        if (payrollStatusUpdate?.id !== undefined){
            
            if (action === "in-review"){
                toast.success("Payroll has been sent for review");
            }
            else{
                toast.success("Payroll updated successfully");
            }
            
            if (payrollStatusUpdate?.status === "approved"){
                dispatch(payrollAction.resetUpdatePayrollStatus());
                history.push("/payroll/" + payrollStatusUpdate?.id + "/finalize");
            }
            else{
                setIsOpen(false);
                setIsOpenRejectPayrun(false);
                refetchPayrollInformation();
                dispatch(payrollAction.resetUpdatePayrollStatus());
            }
        }
        // eslint-disable-next-line
    }, [payrollStatusUpdate]);


    return (
        <>
            <FormDrawer size="3xl" isOpen={isOpen} setIsOpen={setIsOpen}>
                <div className="min-h-screen bg-[#F9FAFB]">
                    <div className="p-6 pb-24">


                        <div className="flex justify-between">
                            <div className="font-medium text-xl">
                                Review Pay Run
                            </div>
                            <div onClick={() => setIsOpen(false)} className="modal-close group">
                                <IconsTimes className="w-3 h-3 m-auto group-hover:svg-fill-white" />
                            </div>
                        </div>


                        <div className="mt-10 box p-0 bg-white">
                            <div className="p-4">
                                <div className="mt-1 flex flex-wrap">
                                    <div className="mr-2 whitespace-nowrap">
                                        Current Pay Run:
                                    </div>
                                    <div className="whitespace-nowrap">
                                        {transformPayrollName(payroll?.name) || "-"}&nbsp;
                                        ({DateFormat(payroll?.payroll_date_range?.start_date) || "-"}
                                        &nbsp;-&nbsp;
                                        {DateFormat(payroll?.payroll_date_range?.end_date) || "-"})
                                    </div>
                                </div>
                            </div>


                            <div className="table-style-2 table-payroll-compare">
                                <Table classTable="no-whitespace">
                                    <Table.Head>
                                        <th>PAY ITEM</th>
                                        <th>AMOUNT</th>
                                    </Table.Head>
                                    <Table.Body>
                                        <tr>
                                            <td>
                                                <div className="font-medium">
                                                    Total Net Pay
                                                </div>
                                            </td>
                                            <td>
                                                <div className="w-max flex flex-wrap space-x-4">
                                                    <span>
                                                        {CurrencyFormat(payroll?.transaction_metrics?.total_net_pay) || "-"}
                                                    </span>
                                                </div>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <div className="font-medium">
                                                    Total Cost 
                                                </div>
                                            </td>
                                            <td>
                                                <div className="w-max flex flex-wrap space-x-4">
                                                    <span>
                                                        {CurrencyFormat(payroll?.transaction_metrics?.total_cost) || "-"}
                                                    </span>
                                                </div>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <div className="font-medium">
                                                    No of Employees
                                                </div>
                                            </td>
                                            <td>
                                                <div className="w-max flex flex-wrap space-x-4">
                                                    <span>
                                                        {NumberFormat(payroll?.transaction_metrics?.number_of_employees, "no-kobo") || "-"}
                                                    </span>
                                                </div>
                                            </td>
                                        </tr>
                                    </Table.Body>
                                </Table>
                                
                                <Maybe condition={payroll?.type === "GROSS"}>
                                    <div className="p-4 font-medium border-t border-gray-200">
                                        Earnings
                                    </div>

                                    <Table classTable="no-whitespace">
                                        <Table.Head>
                                            <th>PAY ITEM</th>
                                            <th>AMOUNT</th>
                                        </Table.Head>
                                        <Table.Body>
                                            <tr>
                                                <td>
                                                    <div className="font-medium">
                                                        Basic Salary (B.H.T)
                                                    </div>
                                                </td>
                                                <td>
                                                    <div className="w-max flex flex-wrap space-x-4">
                                                        <span>
                                                            {CurrencyFormat(payroll?.transaction_metrics?.total_bht) || "-"}
                                                        </span>
                                                    </div>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <div className="font-medium">
                                                        Benefits
                                                    </div>
                                                </td>
                                                <td>
                                                    <div className="w-max flex flex-wrap space-x-4">
                                                        <span>
                                                            {CurrencyFormat(payroll?.transaction_metrics?.total_benefits_in_kind) || "-"}
                                                        </span>
                                                    </div>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <div className="font-medium">
                                                        Allowance
                                                    </div>
                                                </td>
                                                <td>
                                                    <div className="w-max flex flex-wrap space-x-4">
                                                        <span>
                                                            {CurrencyFormat(payroll?.transaction_metrics?.total_bonuses) || "-"}
                                                        </span>
                                                    </div>
                                                </td>
                                            </tr>
                                        </Table.Body>
                                    </Table>

                                    <div className="p-4 font-medium border-t border-gray-200">
                                        Deductions
                                    </div>

                                    <Table classTable="no-whitespace">
                                        <Table.Head>
                                            <th>PAY ITEM</th>
                                            <th>AMOUNT</th>
                                        </Table.Head>
                                        <Table.Body>
                                            <tr>
                                                <td>
                                                    <div className="font-medium">
                                                        Pre-Tax Deductions
                                                    </div>
                                                </td>
                                                <td>
                                                    <div className="w-max flex flex-wrap space-x-4">
                                                        <span>
                                                            {CurrencyFormat(payroll?.transaction_metrics?.total_itf + payroll?.transaction_metrics?.total_nhf + payroll?.transaction_metrics?.total_nsitf) || "-"}
                                                        </span>
                                                    </div>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <div className="font-medium">
                                                        Income Tax
                                                    </div>
                                                </td>
                                                <td>
                                                    <div className="w-max flex flex-wrap space-x-4">
                                                        <span>
                                                            {CurrencyFormat(payroll?.transaction_metrics?.total_paye_tax) || "-"}
                                                        </span>
                                                    </div>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <div className="font-medium">
                                                        Post-Tax Deductions
                                                    </div>
                                                </td>
                                                <td>
                                                    <div className="w-max flex flex-wrap space-x-4">
                                                        <span>
                                                            {CurrencyFormat(payroll?.transaction_metrics?.total_deductions) || "-"}
                                                        </span>
                                                    </div>
                                                </td>
                                            </tr>
                                        </Table.Body>
                                    </Table>
                                </Maybe>
                            </div>
                        </div>

                            
                        <div className="mt-10">
                            <Maybe condition={payroll?.status === "draft"}>
                                <div className="flex flex-wrap">
                                    <ButtonLoader type="button" loading={payrollStatusUpdateLoading} onClick={sendPayrunForApproval} className="btn btn-ep-primary mr-3 mb-3">
                                        Send for Approval
                                    </ButtonLoader>
                                    <button type="button" onClick={() => setIsOpen(false)} className="btn btn-transparent-black mr-3 mb-3">
                                        Cancel
                                    </button>
                                </div>
                            </Maybe>

                            <Maybe condition={payroll?.status === "approved"}>
                                <div className="flex flex-wrap">
                                    <Link to={"/payroll/"+payroll?.id+"/finalize"} className="btn btn-ep-primary mr-3 mb-3">
                                        Finalize Payrun
                                    </Link>
                                    <button type="button" onClick={() => setIsOpen(false)} className="btn btn-transparent-black mr-3 mb-3">
                                        Cancel
                                    </button>
                                </div>
                            </Maybe>

                            <Maybe condition={payroll?.status === "rejected"}>
                                <div className="px-3 py-1 text-red-500 bg-red-100 rounded-md">
                                    This payrun has been rejected
                                </div>
                                <div className="mt-4 flex flex-wrap">
                                    <button type="button" onClick={() => setIsOpen(false)} className="btn btn-transparent-black mr-3 mb-3">
                                        Cancel
                                    </button>
                                </div>
                            </Maybe>

                            <Maybe condition={payroll?.status === "processing" || payroll?.status === "completed"}>
                                <div className="flex flex-wrap">
                                    <Link to={"/payroll/"+payroll?.id+"/finalize"} className="btn btn-ep-primary mr-3 mb-3">
                                        View Payrun
                                    </Link>
                                    <button type="button" onClick={() => setIsOpen(false)} className="btn btn-transparent-black mr-3 mb-3">
                                        Cancel
                                    </button>
                                </div>
                            </Maybe>
                        </div>


                    </div>
                </div>
            </FormDrawer>
        </>
    )
}


export default Index;